var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/LibreDataShare/LibreDataShareConnection/index.tsx";
import React, { useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { fromUnixTime, isAfter } from 'date-fns';
import { ApiStatus } from 'Enums';
import { useApiError, useLibreDataShare } from 'Hooks';
import { Button, Form, Link, Main, RichText, ScrollContainer, TitleActionBar } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import { formatDataShareCode } from 'Utilities/dataHelpers';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const LibreDataShareConnection = ({
  data: {
    dataShareConnection
  }
}) => {
  const [footerLoading, setFooterLoading] = useState(false);
  const {
    monthDate,
    time
  } = formatTimestamp(dataShareConnection?.expiresAt, i18n.language);
  const {
    showStopSharingModal,
    stopDataShare
  } = useLibreDataShare();
  const {
    showApiErrorModal
  } = useApiError();
  const isCodeExpired = () => {
    return dataShareConnection?.expiresAt && isAfter(new Date(), fromUnixTime(dataShareConnection.expiresAt));
  };
  const handleStopSharing = () => {
    if (isCodeExpired()) {
      mediator.publish('router:navigate', '/connections');
      return;
    }
    showStopSharingModal(async () => {
      try {
        setFooterLoading(true);
        await stopDataShare();
        mediator.publish('router:navigate', '/connections');
      } catch (err) {
        const error = err;
        if (error.status === ApiStatus.NOT_FOUND) {
          mediator.publish('router:navigate', '/connections');
          return;
        }
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    }, () => {
      if (isCodeExpired()) {
        mediator.publish('router:navigate', '/connections');
      }
    });
  };
  const handleShareCode = async () => {
    if (isCodeExpired() || !dataShareConnection?.code) {
      mediator.publish('router:navigate', '/connections');
      return;
    }
    notifyApp('adc-webview:data-share-code', {
      message: i18n.t('Connections.content.libreDataShareCard.links.temporaryCode.label', {
        code: formatDataShareCode(dataShareConnection?.code)
      })
    });
  };
  if (!dataShareConnection) {
    mediator.publish('router:navigate', '/connections');
    return null;
  }
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "SharingCodeScreen.title",
    title: i18n.t('Connections.content.libreDataShareCard.primaryText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    testID: "SharingCodeScreen.bodyText",
    fontToken: "$bodyBase.default",
    color: "$text.100",
    text: i18n.t('Connections.content.sharingCodeScreen.bodyText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    alignItems: "center",
    marginTop: "$7",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "SharingCodeScreen.code",
    fontSize: "$dataSmall.medium",
    fontWeight: "$dataSmall.medium",
    color: "$text.100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 15
    }
  }, formatDataShareCode(dataShareConnection.code)), /*#__PURE__*/React.createElement(Text, {
    testID: "SharingCodeScreen.expiresAt",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    color: "$text.100",
    marginTop: "$3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 15
    }
  }, i18n.t('Connections.content.sharingCodeScreen.primaryText', {
    time,
    monthDate
  }))), /*#__PURE__*/React.createElement(Button, {
    testID: "SharingCodeScreen.shareCode-btn",
    padding: "$4",
    flexGrow: 1,
    onPress: handleShareCode,
    variant: "primary",
    "aria-label": i18n.t('Connections.content.sharingCodeScreen.links.shareCodeBtn.label'),
    label: i18n.t('Connections.content.sharingCodeScreen.links.shareCodeBtn.label'),
    marginTop: "$5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$5",
    marginTop: "$3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 13
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 17
    }
  })) : /*#__PURE__*/React.createElement(Link, {
    testID: "SharingCodeScreen.stopSharing-btn",
    onPress: handleStopSharing,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 15
    }
  }, i18n.t('Connections.content.sharingCodeScreen.links.stopSharingBtn.label'))))));
};
export default LibreDataShareConnection;